import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { useAddMoneyStore } from '@/store/useAddMoneyStore'
export const AddMoneyAmountDisplay: React.FC = () => {
  const isFiatMode = useAddMoneyStore((state) => state.isFiatMode)
  const fiatAmount = useAddMoneyStore((state) => state.fiatAmount)
  const cryptoAmount = useAddMoneyStore((state) => state.cryptoAmount)
  const triggerShake = useAddMoneyStore((state) => state.triggerShake)

  const adaptedAmount = isFiatMode ? fiatAmount : cryptoAmount
  const displayAmount = adaptedAmount.amount || '0'

  // Calculate font size based on text length (as in RN)
  const getFontSizeForAmount = (text: string) => {
    const length = text.length
    if (length <= 8) return 64
    if (length <= 12) return 48
    if (length <= 16) return 36
    return 24
  }

  return (
    <BaseView
      center
      style={{
        height: 74,
        justifyContent: 'center',
        alignItems: 'center',
      }}
      className={triggerShake ? 'animate-shake' : ''}
    >
      <BaseText
        fontFamily="bold"
        color="label.default"
        style={{
          fontSize: getFontSizeForAmount(displayAmount),
          lineHeight: 1,
          letterSpacing: '-0.02em',
          maxWidth: '100%',
          textAlign: 'center',
          transition: 'font-size 0.2s ease',
        }}
      >
        {displayAmount}
      </BaseText>

      {/* Display currency code next to the amount */}
      <BaseText
        fontSize={16}
        fontFamily="medium"
        color="label.secondary"
        style={{
          marginTop: 4,
          textAlign: 'center',
        }}
      >
        {adaptedAmount.code}
      </BaseText>
    </BaseView>
  )
}
